import {
  IFavoriteProjectsApi,
  IManagementBackendClient,
  IProjectsApi,
  IReconciliationReportsApi,
  ITransactionReportsApi,
  IQuicksightApi,
  IUsersApi,
} from "@lib/types";
import { BaseClient } from "../base-client";
import { FavoriteProjectsApi } from "./favorite-projects";
import { ProjectsApi } from "./projects";
import { UsersApi } from "./users";
import { QuicksightApi } from "./quicksight";
import { AudiencesApi } from "./audiences";
import { ReconciliationReports } from "./reconciliation-reports";
import { TransactionReports } from "./transaction-reports";

export class ManagementBackendClient
  extends BaseClient
  implements IManagementBackendClient
{
  constructor(baseURL: string) {
    if (!baseURL) throw new Error("Base URL is required");

    super({
      baseURL,
      headers: {
        "Content-Type": "application/json",
      },
    });

    this.Users = new UsersApi(this._instance);
    this.Projects = new ProjectsApi(this._instance);
    this.Quicksight = new QuicksightApi(this._instance);
    this.FavoriteProjects = new FavoriteProjectsApi(this._instance);
    this.Audiences = new AudiencesApi(this._instance);
    this.ReconciliationReports = new ReconciliationReports(this._instance);
    this.TransactionReports = new TransactionReports(this._instance);
  }

  public Users: IUsersApi;
  public Projects: IProjectsApi;
  public Quicksight: IQuicksightApi;
  public FavoriteProjects: IFavoriteProjectsApi;
  public Audiences: AudiencesApi;
  public ReconciliationReports: IReconciliationReportsApi;
  public TransactionReports: ITransactionReportsApi;
}
